import { api } from '@goaltree/backend/convex/_generated/api'
import { useQuery } from 'convex/react'

import { CATEGORY_COLORS, useCategoryFill } from '@/lib/category-color'

// A habit's category colour, for its progress bar and strength ring (pink stays for actions).
export function useHabitAccent(habitId: string | null | undefined): string | undefined {
  const habits = useQuery(api.nodes.getHabits, habitId ? {} : 'skip')
  const fill = useCategoryFill()
  const cat = habitId ? habits?.find((h) => h._id === habitId)?.category : undefined
  return cat ? fill(CATEGORY_COLORS[cat.toLowerCase()] ?? '#8b8b95') : undefined
}
